export default function convertToolbar(_component) {
  return {
    brick: "eo-flex-layout",
    properties: {
      gap: "0.5em",
      alignItems: "center"
    }
  };
}
//# sourceMappingURL=convertToolbar.js.map